import React from "react";

const VisaIcon = () => {
  return (
    <div className="icon-button">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="12"
        viewBox="0 0 37 12"
        fill="none"
      >
        <path
          d="M13.5667 10.924L15.446 0.352539H18.3825L16.5619 10.924H13.5667Z"
          fill="#3C58BF"
        />
        <path
          d="M13.5667 10.924L15.9746 0.352539H18.3825L16.5619 10.924H13.5667Z"
          fill="#293688"
        />
        <path
          d="M27.192 0.469841C26.6047 0.23492 25.665 0 24.4904 0C21.5539 0 19.4396 1.46825 19.4396 3.58254C19.4396 5.16825 20.9079 5.99048 22.0825 6.51905C23.2571 7.04762 23.6095 7.4 23.6095 7.86984C23.6095 8.5746 22.6698 8.92698 21.8476 8.92698C20.673 8.92698 20.0269 8.75079 19.0285 8.33968L18.6174 8.16349L18.2063 10.5714C18.9111 10.8651 20.2031 11.1587 21.5539 11.1587C24.6666 11.1587 26.7222 9.69048 26.7222 7.45873C26.7222 6.2254 25.9587 5.28571 24.1968 4.52222C23.1396 3.99365 22.4936 3.7 22.4936 3.17143C22.4936 2.70159 23.0222 2.23175 24.1968 2.23175C25.1952 2.23175 25.8999 2.40794 26.4285 2.64286L26.7222 2.76032L27.192 0.469841Z"
          fill="#3C58BF"
        />
        <path
          d="M27.192 0.469841C26.6047 0.23492 25.665 0 24.4904 0C21.5539 0 19.9682 1.46825 19.9682 3.58254C19.9682 5.16825 20.9079 5.99048 22.0825 6.51905C23.2571 7.04762 23.6095 7.4 23.6095 7.86984C23.6095 8.5746 22.6698 8.92698 21.8476 8.92698C20.673 8.92698 20.0269 8.75079 19.0285 8.33968L18.6174 8.16349L18.2063 10.5714C18.9111 10.8651 20.2031 11.1587 21.5539 11.1587C24.6666 11.1587 26.7222 9.69048 26.7222 7.45873C26.7222 6.2254 25.9587 5.28571 24.1968 4.52222C23.1396 3.99365 22.4936 3.7 22.4936 3.17143C22.4936 2.70159 23.0222 2.23175 24.1968 2.23175C25.1952 2.23175 25.8999 2.40794 26.4285 2.64286L26.7222 2.76032L27.192 0.469841Z"
          fill="#293688"
        />
        <path
          d="M32.2429 0.352539C31.5381 0.352539 31.0096 0.41127 30.7159 1.11603L26.3112 10.924H29.4826L30.0699 9.16206H33.8286L34.181 10.924H37L34.5334 0.352539H32.2429ZM30.8921 7.40016C31.0683 6.87159 32.0667 4.28746 32.0667 4.28746C32.0667 4.28746 32.3016 3.64143 32.4778 3.23032L32.654 4.22873C32.654 4.22873 33.2413 6.87159 33.3588 7.45889H30.8921V7.40016Z"
          fill="#3C58BF"
        />
        <path
          d="M32.9477 0.352539C32.2429 0.352539 31.7143 0.41127 31.4207 1.11603L26.3112 10.924H29.4826L30.0699 9.16206H33.8286L34.181 10.924H37L34.5334 0.352539H32.9477ZM30.8921 7.40016C31.127 6.81286 32.0667 4.28746 32.0667 4.28746C32.0667 4.28746 32.3016 3.64143 32.4778 3.23032L32.654 4.22873C32.654 4.22873 33.2413 6.87159 33.3588 7.45889H30.8921V7.40016Z"
          fill="#293688"
        />
        <path
          d="M8.16355 7.7524L7.8699 6.22542C7.34133 4.46351 5.63815 2.52542 3.75879 1.58574L6.40165 10.9826H9.57307L14.3302 0.411133H11.1588L8.16355 7.7524Z"
          fill="#3C58BF"
        />
        <path
          d="M8.16355 7.7524L7.8699 6.22542C7.34133 4.46351 5.63815 2.52542 3.75879 1.58574L6.40165 10.9826H9.57307L14.3302 0.411133H11.7461L8.16355 7.7524Z"
          fill="#293688"
        />
        <path
          d="M0 0.352539L0.528571 0.47C4.2873 1.35095 6.87143 3.5827 7.86984 6.22556L6.8127 1.23349C6.63651 0.52873 6.10794 0.352539 5.46191 0.352539H0Z"
          fill="#FFBC00"
        />
        <path
          d="M0 0.352539C3.75873 1.23349 6.87143 3.52397 7.86984 6.16683L6.87143 1.99698C6.69524 1.29222 6.10794 0.881111 5.46191 0.881111L0 0.352539Z"
          fill="#F7981D"
        />
        <path
          d="M0 0.352539C3.75873 1.23349 6.87143 3.52397 7.86984 6.16683L7.16508 3.87635C6.98889 3.17159 6.75397 2.46682 5.93175 2.17317L0 0.352539Z"
          fill="#ED7C00"
        />
        <path
          d="M11.1 7.39987L9.10322 5.40305L8.16354 7.63479L7.92862 6.16654C7.40004 4.40463 5.5 2.49988 3.8175 1.52686L6.46036 10.9237H9.63179L11.1 7.39987Z"
          fill="#051244"
        />
        <path
          d="M16.5619 10.9237L14.0366 8.3396L13.5667 10.9237H16.5619Z"
          fill="#051244"
        />
        <path
          d="M23.3159 7.28247C23.5509 7.51739 23.6683 7.69358 23.6096 7.9285C23.6096 8.63327 22.6699 8.98565 21.8477 8.98565C20.6731 8.98565 20.0271 8.80946 19.0286 8.39834L18.6175 8.22215L18.2064 10.6301C18.9112 10.9237 20.2032 11.2174 21.554 11.2174C23.4334 11.2174 24.9604 10.6888 25.8413 9.74914L23.3159 7.28247Z"
          fill="#051244"
        />
        <path
          d="M26.7223 10.9236H29.4826L30.0699 9.16173H33.8286L34.181 10.9236H37.0001L36.0017 6.63633L32.4778 3.22998L32.654 4.16966C32.654 4.16966 33.2413 6.81252 33.3588 7.39982H30.8921C31.1271 6.81252 32.0667 4.28712 32.0667 4.28712C32.0667 4.28712 32.3017 3.64109 32.4778 3.22998"
          fill="#051244"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="16"
        fill="none"
        viewBox="0 0 26 16"
      >
        <path
          fill="#DFAC16"
          fillRule="evenodd"
          d="M25.858 7.724c.001 4.265-3.463 7.723-7.737 7.724-4.274.001-7.74-3.455-7.74-7.72v-.004C10.38 3.46 13.844.001 18.117 0c4.274-.001 7.74 3.455 7.741 7.72v.004z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#BF3126"
          fillRule="evenodd"
          d="M7.689.002C3.44.029 0 3.478 0 7.724c0 4.263 3.467 7.722 7.739 7.722a7.719 7.719 0 005.207-2.012h.001c.282-.256.544-.532.786-.827h-1.586a7.535 7.535 0 01-.577-.795h2.735c.166-.266.317-.542.45-.827H11.12a7.613 7.613 0 01-.323-.812h4.283a7.728 7.728 0 00.22-4.103h-4.73a7.69 7.69 0 01.22-.81h4.285a7.702 7.702 0 00-.333-.828h-3.623a7.4 7.4 0 01.444-.81h2.733a7.743 7.743 0 00-.6-.828H12.17a7.18 7.18 0 01.776-.78A7.72 7.72 0 007.74.002h-.05z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M10.522 9.69l.103-.699c-.057 0-.14.024-.213.024-.286 0-.318-.152-.3-.264l.232-1.426h.436l.105-.773h-.411l.084-.481h-.824c-.018.018-.487 2.704-.487 3.03 0 .485.273.7.657.697.3-.002.535-.086.618-.108zM10.783 8.358c0 1.162.768 1.438 1.423 1.438.604 0 .87-.135.87-.135l.145-.793s-.46.202-.874.202c-.885 0-.73-.658-.73-.658h1.674s.108-.533.108-.75c0-.542-.27-1.202-1.175-1.202-.828 0-1.441.89-1.441 1.898zm1.444-1.162c.466 0 .38.522.38.564h-.915c0-.054.086-.564.535-.564zM17.445 9.69l.148-.896s-.405.202-.682.202c-.585 0-.819-.445-.819-.924 0-.97.503-1.505 1.063-1.505.42 0 .756.236.756.236l.135-.871s-.5-.202-.928-.202c-.951 0-1.876.823-1.876 2.37 0 1.025.5 1.703 1.482 1.703.278 0 .721-.113.721-.113zM5.99 6.473c-.565 0-.998.181-.998.181l-.12.708s.358-.145.898-.145c.307 0 .531.035.531.284 0 .15-.027.207-.027.207s-.242-.02-.354-.02c-.713 0-1.462.303-1.462 1.218 0 .72.492.886.796.886.581 0 .832-.376.845-.377l-.027.314h.726l.323-2.265c0-.96-.84-.991-1.131-.991zm.176 1.844c.016.138-.087.786-.583.786-.256 0-.322-.195-.322-.31 0-.225.122-.495.726-.495.14 0 .156.015.18.019zM7.892 9.776c.186 0 1.247.047 1.247-1.046 0-1.021-.982-.82-.982-1.23 0-.204.16-.268.452-.268.117 0 .564.037.564.037l.103-.726s-.289-.065-.76-.065c-.61 0-1.228.243-1.228 1.074 0 .94 1.032.846 1.032 1.243 0 .265-.289.286-.51.286-.385 0-.731-.131-.732-.125l-.11.719c.02.006.233.1.924.1zM24.27 5.821l-.177 1.1s-.31-.427-.796-.427c-.755 0-1.384.909-1.384 1.952 0 .674.335 1.334 1.021 1.334.494 0 .768-.343.768-.343l-.037.293h.802l.63-3.91-.827.001zm-.382 2.146c0 .434-.216 1.014-.663 1.014-.296 0-.435-.248-.435-.638 0-.637.287-1.058.649-1.058.296 0 .449.203.449.682zM1.528 9.734l.502-2.952.074 2.952h.567l1.06-2.952-.47 2.952h.844l.65-3.916H3.45l-.812 2.403-.043-2.403H1.393L.734 9.734h.794zM14.223 9.739c.24-1.361.285-2.466.857-2.264.1-.527.197-.73.306-.953 0 0-.051-.011-.159-.011-.369 0-.642.503-.642.503l.073-.462h-.767l-.514 3.187h.846zM19.346 6.473c-.565 0-.998.181-.998.181l-.12.708s.358-.145.899-.145c.306 0 .53.035.53.284 0 .15-.027.207-.027.207s-.242-.02-.354-.02c-.712 0-1.46.303-1.46 1.218 0 .72.49.886.794.886.582 0 .832-.376.846-.377l-.027.314h.725l.324-2.265c0-.96-.84-.991-1.132-.991zm.177 1.844c.016.138-.087.786-.583.786-.256 0-.322-.195-.322-.31 0-.225.122-.495.726-.495.14 0 .155.015.18.019zM21.14 9.739c.24-1.361.285-2.466.857-2.264.1-.527.198-.73.307-.953 0 0-.051-.011-.159-.011-.369 0-.642.503-.642.503l.073-.462h-.767l-.514 3.187h.846z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
    // <svg
    //   width="130"
    //   height="65"
    //   viewBox="0 0 130 65"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g filter="url(#filter0_d_24_1059)">
    //     <rect x="5" y="5" width="120" height="55" rx="7" fill="#F3F9FF" />
    //   </g>
    //   <defs>
    //     <filter
    //       id="filter0_d_24_1059"
    //       x="0"
    //       y="0"
    //       width="130"
    //       height="65"
    //       filterUnits="userSpaceOnUse"
    //       color-interpolation-filters="sRGB"
    //     >
    //       <feFlood flood-opacity="0" result="BackgroundImageFix" />
    //       <feColorMatrix
    //         in="SourceAlpha"
    //         type="matrix"
    //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    //         result="hardAlpha"
    //       />
    //       <feMorphology
    //         radius="1"
    //         operator="dilate"
    //         in="SourceAlpha"
    //         result="effect1_dropShadow_24_1059"
    //       />
    //       <feOffset />
    //       <feGaussianBlur stdDeviation="2" />
    //       <feComposite in2="hardAlpha" operator="out" />
    //       <feColorMatrix
    //         type="matrix"
    //         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
    //       />
    //       <feBlend
    //         mode="normal"
    //         in2="BackgroundImageFix"
    //         result="effect1_dropShadow_24_1059"
    //       />
    //       <feBlend
    //         mode="normal"
    //         in="SourceGraphic"
    //         in2="effect1_dropShadow_24_1059"
    //         result="shape"
    //       />
    //     </filter>
    //   </defs>
    // </svg>
  );
};

export default VisaIcon;
